import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ClientModel } from '../../../shared/models/client.model';
import { SubscriptionModel } from '../../../shared/models/subscription.model';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CommonHttpService } from '../../../shared/services/http.service';
import { AuthenticatedUserRepositoryService } from '../../../payment/services/authenticated-user-repository.service';
import { TranslateService } from '@ngx-translate/core';
import { Response } from '@angular/http';
import { OauthService } from '../../../shared/services/oauth.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'account-subscriptions-details',
    templateUrl: './account.subscriptions.details.component.html',
    styleUrls: ['./../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsComponent implements OnInit, OnDestroy {
    public id;
    public loading = false;
    public loadingSubscription = false;
    public error = false;
    public client: ClientModel;
    public subscription: SubscriptionModel;
    public showAddressUpdate = false;
    public cancelAllowedStatuses: string[] = ['active'];

    oauthLoadedAuthenticatedUser: Subscription;

    constructor(
        protected route: ActivatedRoute,
        protected translate: TranslateService,
        protected titleService: Title,
        protected http: CommonHttpService,
        protected authenticatedUserRepository: AuthenticatedUserRepositoryService,
        protected oauth: OauthService,
        protected router: Router
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.oauth.init();
            }
        });
        this.oauthLoadedAuthenticatedUser = this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.showSubscription();
        });
    }

    ngOnDestroy() {
        // It's going to be overrided by AutoUnsubscribe
    }
    ngOnInit () {
        if (undefined === this.client) {
            this.client = this.authenticatedUserRepository.getUser();
        }

        const configs = this.route.snapshot.data.storeConfigurations;
        this.showAddressUpdate = configs !== undefined
            && configs['account-subscription-update-address'] !== undefined
            && configs['account-subscription-update-address'] !== null;

        const cancelStatusConfig = configs !== undefined ? configs['allow-to-cancel-subscription-in-status'] : null;
        if (cancelStatusConfig && typeof cancelStatusConfig === 'string' && cancelStatusConfig.trim() !== '') {
            this.cancelAllowedStatuses = cancelStatusConfig.split(',').map((s: string) => s.trim()).filter((s: string) => s !== '');
        }

        this.route.params.subscribe(params => {
            this.id = +params['id'];
            this.translate
                .get('ACCOUNT.SUBSCRIPTIONS.DETAILS.TITLE', {id: this.id})
                .subscribe((title: string) => {
                    this.titleService.setTitle(title);
                });
            this.showSubscription();
        });
    }

    /**
     * Call api to load subscription data
     **/
    public showSubscription() {
        if (null === this.client || undefined === this.id || this.loadingSubscription) {
            return;
        }

        this.loadingSubscription = true;
        this.loading = true;
        this.http
            .useAuth()
            .get(`account/clients/${this.client.id}/subscriptions/${this.id}`)
            .subscribe(
                (response: Response) => {
                    this.subscription = response.json().data;
                    this.loading = false;
                    this.loadingSubscription = false;
                },
                () => {
                    this.error = true;
                    this.loading = false;
                    this.loadingSubscription = false;
                }
            );
    }

    /**
     * Check if subscription status is 'inactive'
     **/
    public isInactive() {
        return undefined !== this.subscription
            && this.subscription.status === 'inactive';
    }

    /**
     * Check if subscription status is 'active'
     **/
    public isActive() {
        return undefined !== this.subscription
            && this.subscription.status === 'active';
    }

    /**
     * Check if subscription status is 'processing'
     **/
    public isProcessing() {
        return undefined !== this.subscription
            && this.subscription.status === 'processing';
    }

    /**
     * Check if subscription status is 'finalized'
     **/
    public isFinalized() {
        return undefined !== this.subscription
            && this.subscription.status === 'finalized';
    }

    /**
     * Check if subscription status is 'overdue'
     **/
    public isOverdue() {
        return undefined !== this.subscription
            && this.subscription.status === 'overdue';
    }

    /**
     * Check if subscription status is 'paused'
     **/
    public isPaused() {
        return undefined !== this.subscription
            && this.subscription.status === 'paused';
    }

    public canShowCancelButton(): boolean {
        return undefined !== this.subscription
            && this.cancelAllowedStatuses.includes(this.subscription.status);
    }

    public updated(subscription: SubscriptionModel) {
        this.subscription = subscription;
    }

    /**
     * Gets the date of the most recent order of the subscription
     */
    public getLatestOrderDateSchedule(): string | null {
        if (!this.subscription || !this.subscription.orders || this.subscription.orders.length === 0) {
            return null;
        }

        const latestOrder = this.subscription.orders
            .filter(order => order.schedule && order.schedule.date)
            .sort((a, b) => new Date(b.schedule.date).getTime() - new Date(a.schedule.date).getTime())[0];

        return latestOrder ? latestOrder.schedule.date : null;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/account/subscriptions/details/account.subscriptions.details.component.ts